<template>
  <h4
    class="block tracking-wide text-gray-700 text-sm font-bold mb-2"
    for="ausbildung"
  >
    {{ title }}
  </h4>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    title: String,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>